// ======================================================================
// File Name       : ReserveEmailSearch
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Col, Form } from 'react-bootstrap';
import { VALIDATE_TYPE } from '../../constants';
import RenderField from '../../utils/ReduxFormUtils';
import CustomButton from '../button/CustomButton';
import ReduxFormPaging from '../ReduxFormPaging';

class ReserveEmailSearch extends React.Component {
  render() {
    const {
      recordNum,
      onSearchBtnClick,
      getStartEndData,
    } = this.props;
    return (
      <div>
        <h3>検索する項目を指定してください</h3>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            onSearchBtnClick();
          }}
          className='form-horizontal'
        >
          <Col sm={12} className="padding-top-10">
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                件名
              </Col>
              <Col sm={7}>
                <RenderField type="text" name="reservedEmailTitle" label="件名" value />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
              予約日時
              </Col>
              <Col sm={3}>
                <RenderField
                  type="datetime"
                  name="reservedDateFrom"
                  validates={[VALIDATE_TYPE.DATE_TIME]}
                  normalizeDateTime
                  shouldDisableDate
                  showHour
                />
              </Col>
              <Col sm={1} className="text-center" as={Form.Label}>
                ～
              </Col>
              <Col sm={3}>
                <RenderField
                  type="datetime"
                  name="reservedDateTo"
                  validates={[VALIDATE_TYPE.DATE_TIME]}
                  normalizeDateTime
                  shouldDisableDate
                  showHour
                  isDateTo
                />
              </Col>
            </Form.Group>
            <Col sm={12}>
              <RenderField
                name="dateTimeMinMax"
                type="dateTimeMinMax"
                validates={[VALIDATE_TYPE.DATE_TIME_MIN_MAX]}
                keyDateFrom={'reservedDateFrom'}
                keyDateTo={'reservedDateTo'}
              />
            </Col>
            <Form.Group className="text-center">
              <Col sm={12} className="margin-bottom-20">
                <CustomButton
                  btnStyle="btn btn-primary btn-96"
                  type="submit"
                  iconClass="bi bi-search"
                  text="検索"
                />
              </Col>
            </Form.Group>
          </Col>
        </Form>
      </div>
    );
  }
}

export default ReserveEmailSearch;
